import { StorageScope } from "../../../../services/api/instances/storageApi/types/service_types";
import { LAST_SELECTED_KEY } from "../constants";

export function setLastSelectedId(id: string, service: StorageScope) {
  const lastSelected = localStorage.getItem(LAST_SELECTED_KEY);
  if (lastSelected) {
    const raw = JSON.parse(lastSelected);
    if (raw) {
      raw[service] = {
        id,
        timestamp: Date.now(),
      };
      localStorage.setItem(LAST_SELECTED_KEY, JSON.stringify(raw));
      return;
    } else {
      console.error(
        "Не удалось сохранить последний выбранный объект в localStorage",
      );
      return;
    }
  }
  const raw = {
    [service]: {
      id,
      timestamp: Date.now(),
    },
  };
  localStorage.setItem(LAST_SELECTED_KEY, JSON.stringify(raw));
}
